import React, { useContext  } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Grid, Transition, Container, Header, Dimmer, Loader } from 'semantic-ui-react';
import Emoji from '../components/Emoji';
import FloatingActionButton from '../components/FloatingActionButton/FloatingActionButton';

import { AuthContext } from '../context/auth';
import PostCard from '../components/PostCard';
import { FETCH_POSTS_QUERY } from '../util/graphql';

function Home() {
  const { user } = useContext(AuthContext);
  const {
    loading,
    data: { getPosts: posts }
  } = useQuery(FETCH_POSTS_QUERY);
  
  const createPostButton = user ? (
      <FloatingActionButton icon="plus" text="Create Your Own Post!" to="/createPost" color="red" />
      
  ) : (
      <FloatingActionButton icon="plus" text="Create Your Own Post!" to="/login" color="red" />
      
  );

  return (
    <>
    <Container text>
    <Header textAlign="center" as='h1'> <Emoji symbol=" 🍵 🥤 🍶 🍺 🍻 🍣 🍱 🥟 🍤" /> <br/>Welcome to Your Free Food Finder!<br/> <Emoji symbol="🥗 🍬 🥘 🥫 🍝 🍰 🎂 🍮 🍭 " /></Header>
    <Header textAlign="justified" as='h3'>
      Do you love free food? <Emoji symbol="✨ 😋" /> Are you too lazy to cook? <Emoji symbol="🥺" /> <br/>
      Do you wish there was an app to let you know about events near you with free food ? <Emoji symbol="🥺" />  <br/>
      Say no more! This app is for you ! <Emoji symbol="🥰 🤸🏿‍♀️ 🎁 🎈" />
      <ul>
      <li> You can see all posts with free food. No sign up to see them. </li>
      <li> You can upvote <Emoji symbol="👍" />or downvote <Emoji symbol="👎" /> them.   </li>
      <li> You got power <Emoji symbol="💪" />. Upvoted posts appear at the top. <Emoji symbol="✨ 😋" />  </li>
      <li> You can also comment on others' post. Our users usually comment when they like/dislike the food, or the event is public/private, or food is gone to let others know. </li>
      <li> You can also get notifications when there is a new post near you. <Emoji symbol="🗺️ 🏘️ 🏨" /></li>
      <li> If your posts get upvotes, you get to become one of the FIRST to be notified. <Emoji symbol="🔔" /> </li>
      <li> Please respect the community when you post or comment.<Emoji symbol="😌" />  </li>
      <li> We constantly monitor all posts. <Emoji symbol="🧐" />  </li>
      <li> We strive for creating a respectful community.</li>
      </ul> 
       
    </Header>
    </Container>

    <Grid columns={1}>
      <Grid.Row className="page-title">
        
        <h1>Recent Posts </h1>
      </Grid.Row>
      <Grid.Row>
      
        {loading ? (
          <>
          <h1>Loading posts..</h1>
          <br />
          <Dimmer active inverted className={{marginTop: 20}}>
            <Loader size="Massive" inverted content="Our bots are working hard!"/>
            <Emoji symbol="⚒️  🤖 🧰 🔨 ⚙️" />
          </Dimmer>
          </>
    
        ) : (
          <Transition.Group>
            {createPostButton}
            {posts &&
              posts.map((post) => (
                <Grid.Column key={post.id} style={{ marginTop: 20 }}>
                  <PostCard post={post} />
                </Grid.Column>
              ))}
          </Transition.Group>
        )}
      </Grid.Row>
    </Grid>
    </>
  );
}

export default Home;
